import React from 'react';
import classNames from 'classnames';

import css from './IconArrow.module.css';

const DIRECTION_RIGHT = 'right';
const DIRECTION_LEFT = 'left';

/**
 * Icon with arrow head pointing to given direction and with given size.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {('right' | 'left' | 'down' | 'up')} props.direction
 * @param {('small' | 'big')} props.size
 * @returns {JSX.Element} arrow head icon
 */
const IconArrow = props => {
  const { className, rootClassName, direction } = props;
  const classes = classNames(rootClassName || css.root, className);

  const isRight = direction === DIRECTION_RIGHT;
  const isLeft = direction === DIRECTION_LEFT;

  if (isLeft) {
    return (
      <svg
        className={classes}
        width="13"
        height="28"
        viewBox="0 0 13 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 2.33368L1.5 14.0003L11.5 25.667"
          stroke="#113A69"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  } else if (isRight) {
    return (
      <svg
        className={classes}
        width="13"
        height="28"
        viewBox="0 0 13 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 2.33368L11.5 14.0003L1.5 25.667"
          stroke="#113A69"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
};

export default IconArrow;
